import {FC, useEffect, useMemo, useState} from 'react'
import {KTCard, KTCardBody, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {Column} from 'react-table'
import {BedBookingModel} from '../../../../models/booking.model'
import {
  getGrupoByUsuario,
  postRelevoAgregarUsuario,
  postRelevoAgregarHabitacion,
  deleteRelevoHabitacion,
  deleteRelevoUsuario,
} from '../../../../services/relevo.service'
import {Button} from '../../../../../../components/UI/Button'
import {ModalComponent} from '../../../../../../components/Layout/Modal'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {
  newRelevoUsuarioSchema,
  newRelevoHabitacionSchema,
} from '../../../../../../util/validationHoteleria'
import {
  GuestModel,
  RelevoBedModel,
  RelevoGuestModel,
  RelevoHabitacionRequestModel,
  RelevoResponseModel,
  RelevoUsuarioRequestModel,
} from '../../model'
import {ShowSnackBar} from '../../../../../../util/functions'
import {Select} from '../../../../../../components/UI/Select'
import AsyncSelect from 'react-select/async'
import Swal from 'sweetalert2'
import {paginationGuestsService} from '../../services'
import {SelectAsync} from '../../../../../../components/UI/SelectV2'
import {getModulesService} from '../../../modules/services'
import {ModuleModel} from '../../../modules/models'
import {BedModel} from '../../../bed/model'
import {getRoomsService} from '../../../room/services'
import {RoomModel} from '../../../room/models'
import {getBedsService} from '../../../bed/services'

const TableGuests: FC<{relevoId: string; usuarios: RelevoGuestModel[]; actualizar: () => void}> = ({
  relevoId,
  usuarios = [],
  actualizar,
}) => {
  const {data, setData, loading, setLoading} = useKTable()
  const {currentTabItem} = useHoteleria()
  const [showModal, setShowModal] = useState<boolean>(false)
  const methods = useForm<RelevoUsuarioRequestModel>({
    resolver: yupResolver(newRelevoUsuarioSchema),
  })

  const {
    watch,
    control,
    setValue,
    handleSubmit,
    setError,
    reset,
    formState: {errors},
  } = methods

  const onSubmit = async (data: RelevoUsuarioRequestModel) => {
    try {
      setLoading(true)
      data.RelevoId = relevoId ?? null // currentTabItem?.objectInfo.RelevoId ?? null;
      data.CampamentoId = currentTabItem?.objectInfo.CampamentoId
      data.UsuarioId = currentTabItem?.objectInfo.UsuarioId
      var resp = await postRelevoAgregarUsuario(data)
      if (!resp?.data?.error) {
        ShowSnackBar('El relevo se agregó correctamente.')
      } else {
        ShowSnackBar('Error al agregar relevo.', 'error')
      }
    } catch (error) {
    } finally {
      actualizar()
      setLoading(false)
      handleClose()
    }
  }

  const getHuespedes = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 2000,
        CampamentoId: currentTabItem?.objectInfo?.CampamentoId || null,
        isCombo: true,
        BuscaTexto: inputValue,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const handleClose = () => {
    setShowModal(false)
    reset()
  }

  const handleOpen = () => {
    reset()
    setShowModal(true)
  }

  const handleEliminarRelevoUsuario = async (data: RelevoGuestModel) => {
    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Al eliminar no podrás revertir esta acción',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          setLoading(true)
          var resp = await deleteRelevoUsuario([{Id: data.Id.toString()}])
          if (!resp?.data?.error) {
            ShowSnackBar('El relevo se eliminó correctamente.')
          } else {
            ShowSnackBar('Error al eliminar relevo.', 'error')
          }
          actualizar()
          setLoading(false)
          Swal.close()
        } else if (result.isDenied) {
          //Swal.fire('Changes are not saved', '', 'info')
        }
      })
    } catch (error) {}
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (usuarios) {
      setData(usuarios)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuarios])

  const columns: Column<RelevoGuestModel>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Numero de Documento' name='NumeroDocumento' />
        ),
        accessor: 'NumeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombre Completo' name='Usuario_descripcion' />
        ),
        accessor: 'Usuario_descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Eliminar' />,
        id: 'actions',
        Cell: ({...props}) => (
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleEliminarRelevoUsuario(props.row.original)}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
            </a>
          </div>
        ),
      },
    ],
    [data],
  )

  const handleSetGuestInfo = async (val: any) => {
    let value = val ? val.value : ''
    console.log('value => ', value)
    console.log('val => ', val)

    setValue('NuevoUsuarioId', value)
    setValue('NombreUsuario', val.label)
    // setValue('Huesped_Empresa', val.Empresa_descripcion)
    // setValue('Huesped_Telefono', val.Telefono)
    // setValue('Huesped_Email', val.Email)
    // setValue('Huesped_Tipo', val.TipoHuesped_descripcion)
    // setValue('Huesped_Modulo', '')
    // setValue('Huesped_Habitacion', '')
    // setValue('Huesped_Cama', '')
    // setValue('ReservaCamaId', '')
    // setError('HuespedId', {})
    //
    // const { data } = await getGuestLastBookingByIdService(value)
    // if (!data.error) {
    //     const guest = data.data
    //     setError('HuespedId', {})
    //     setValue('Huesped_Modulo', guest.UltimaReserva_ModuloId)
    //     setValue('Huesped_Habitacion', guest.UltimaReserva_HabitacionId)
    //     setValue('Huesped_Cama', guest.UltimaReserva_CamaId)
    //     setValue('ReservaCamaId', guest.UltimaReserva_ReservaCamaId)
    // }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex align-items-center justify-content-between ps-6 pt-6 pe-6'>
          <h4 className='mb-0'>Relevos</h4>
          <Button label='Agregar Relevo' onClick={handleOpen} />
        </div>
        <KTCardBody>
          <KTable
            data={data}
            columns={columns as any}
            showPagination={false}
            classNameProps='min-height-150'
          />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCardBody>
      </KTCard>
      <ModalComponent
        show={showModal}
        size='md'
        title={'Huespedes disponibles'}
        handleClose={handleClose}
        handleSubmit={handleSubmit(onSubmit)}
      >
        <FormProvider {...methods}>
          <div className='mb-2 col-sm-12 col-md-6'>
            <label className='required form-label'>Huespedes</label>
            <SelectAsync
              loadOptions={getHuespedes as any}
              name='NuevoUsuarioId'
              value={
                watch('NuevoUsuarioId')
                  ? {
                      value: watch('NuevoUsuarioId') || '',
                      label: watch('NombreUsuario') || '',
                    }
                  : null
              }
              onChangeValue={handleSetGuestInfo}
              textPlaceholder='Buscar Huésped...'
            />
          </div>
        </FormProvider>
      </ModalComponent>
    </>
  )
}

const TableBeds: FC<{relevoId: string; habitaciones: RelevoBedModel[]; actualizar: () => void}> = ({
  relevoId,
  habitaciones = [],
  actualizar,
}) => {
  const {data, setData, loading, setLoading} = useKTable()
  const {currentTabItem} = useHoteleria()
  const [modules, setModules] = useState<ModuleModel[] | any>([])
  const [rooms, setRooms] = useState<RoomModel[] | any>([])
  const [beds, setBeds] = useState<BedModel[] | any>([])
  const [showModal, setShowModal] = useState<boolean>(false)
  const methods = useForm<RelevoHabitacionRequestModel>({
    resolver: yupResolver(newRelevoHabitacionSchema),
  })

  const {
    watch,
    control,
    handleSubmit,
    reset,
    formState: {errors},
  } = methods

  const getModules = async () => {
    const {data: response} = await getModulesService({
      CampamentoId: currentTabItem?.objectInfo.CampamentoId,
      pageNumber: 1,
      size: 1000,
    })
    const mappedModules = response.data?.map((item) => ({
      value: item.Id,
      label: item.Codigo,
    }))
    setModules(mappedModules)
  }

  const getRooms = async (moduloId: string) => {
    const {data: response} = await getRoomsService({
      pageNumber: 1,
      size: 1000,
      ModuloId: moduloId,
    })
    const mappedRooms = response?.data?.map((item) => ({
      value: item.Id,
      label: item.Codigo,
    }))
    setRooms(mappedRooms)
  }

  const getBeds = async (habitacionId: string) => {
    const {data: response} = await getBedsService({
      pageNumber: 1,
      size: 1000,
      HabitacionId: habitacionId,
    })
    const mappedBeds = response?.data?.map((item) => ({
      value: item.Id,
      label: item.Codigo,
    }))
    setBeds(mappedBeds)
  }

  const handleClose = () => {
    setShowModal(false)
    reset()
  }

  const handleOpen = () => {
    reset()
    setShowModal(true)
  }

  const handleEliminarRelevoHabitacion = async (data: RelevoBedModel) => {
    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Al eliminar no podrás revertir esta acción',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          setLoading(true)
          var resp = await deleteRelevoHabitacion([{Id: data.Id.toString()}])
          if (!resp?.data?.error) {
            ShowSnackBar('La habitación se eliminó correctamente.')
          } else {
            ShowSnackBar('Error al eliminar habitación.', 'error')
          }
          actualizar()
          setLoading(false)
          Swal.close()
        } else if (result.isDenied) {
          //Swal.fire('Changes are not saved', '', 'info')
        }
      })
    } catch (error) {}
  }

  const onSubmit = async (data: RelevoHabitacionRequestModel) => {
    try {
      setLoading(true)

      data.RelevoId = relevoId ?? null
      data.CampamentoId = currentTabItem?.objectInfo.CampamentoId
      data.UsuarioId = currentTabItem?.objectInfo.UsuarioId
      var resp = await postRelevoAgregarHabitacion(data)
      if (!resp?.data?.error) {
        ShowSnackBar('El relevo se agregó correctamente.')
      } else {
        ShowSnackBar(resp?.data?.message || 'Error al agregar relevo.', 'error')
      }
    } catch (error) {
    } finally {
      actualizar()
      setLoading(false)
      handleClose()
    }
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (showModal) {
      getModules()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal])

  useEffect(() => {
    const moduloId = watch('ModuloId')
    if (moduloId) {
      getRooms(moduloId)
    } else {
      setRooms([])
    }
  }, [watch('ModuloId')])

  useEffect(() => {
    const habitacionId = watch('HabitacionId')
    if (habitacionId) {
      getBeds(habitacionId)
    } else {
      setBeds([])
    }
  }, [watch('HabitacionId')])

  useEffect(() => {
    if (habitaciones) {
      setData(habitaciones)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [habitaciones])

  const columns: Column<RelevoBedModel>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Modulo' name='Modulo_descripcion' />
        ),
        accessor: 'Modulo_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Habitación' name='Habitacion_descripcion' />
        ),
        accessor: 'Habitacion_descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cama' name='Cama_descripcion' />,
        accessor: 'Cama_descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Eliminar' />,
        id: 'actions',
        Cell: ({...props}) => (
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleEliminarRelevoHabitacion(props.row.original)}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
            </a>
          </div>
        ),
      },
    ],
    [data],
  )

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex align-items-center justify-content-between ps-6 pt-6 pe-6'>
          <h4 className='mb-0'>Habitaciones</h4>
          <Button label='Agregar Habitación' onClick={handleOpen} />
        </div>
        <KTCardBody>
          <KTable
            data={data}
            columns={columns as any}
            showPagination={false}
            classNameProps='min-height-150'
          />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCardBody>
      </KTCard>
      <ModalComponent
        show={showModal}
        size='md'
        title={'Huespedes disponibles'}
        handleClose={handleClose}
        handleSubmit={handleSubmit(onSubmit)}
      >
        <FormProvider {...methods}>
          <div className='mb-2 col-sm-12 col-md-12'>
            <label className='required form-label'>Modulo</label>
            <Select control={control as any} name='ModuloId' data={modules} errors={errors} />
          </div>
          <div className='mb-2 col-sm-12 col-md-12'>
            <label className='required form-label'>Habitación</label>
            <Select control={control as any} name='HabitacionId' data={rooms} errors={errors} />
          </div>
          <div className='mb-2 col-sm-12 col-md-12'>
            <label className='required form-label'>Cama</label>
            <Select control={control as any} name='CamaId' data={beds} errors={errors} />
          </div>
        </FormProvider>
      </ModalComponent>
    </>
  )
}

const TableRelevosWrapper = () => {
  const {currentTabItem} = useHoteleria()
  const [usuariosRelevo, setUsuariosRelevo] = useState<RelevoGuestModel[] | any>([])
  const [habitacionesRelevo, setHabitacionesRelevo] = useState<RelevoBedModel[] | any>([])
  const [relevoId, setRelevoId] = useState<string>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const getRelevos = async () => {
    console.log('?')
    try {
      setLoading(true)
      if (currentTabItem?.objectInfo?.UsuarioId !== null) {
        const {data: response} = await getGrupoByUsuario(
          currentTabItem.objectInfo.UsuarioId,
          currentTabItem.idToEdit as any,
        )
        console.log('response?', response)
        if (response.error === false) {
          console.log('Entro?')
          if (response.data.RelevoId) setRelevoId(response.data.RelevoId.toString())
          if (response.data.Miembros) setUsuariosRelevo(response.data.Miembros)
          if (response.data.Habitaciones) setHabitacionesRelevo(response.data.Habitaciones)
        }
      }
    } catch (error) {
      console.log('ERROR => ', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getRelevos()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  return (
    <>
      {!loading && (
        <>
          <KTableProvider>
            <TableGuests relevoId={relevoId} usuarios={usuariosRelevo} actualizar={getRelevos} />
          </KTableProvider>
          <KTableProvider>
            <TableBeds
              relevoId={relevoId}
              habitaciones={habitacionesRelevo}
              actualizar={getRelevos}
            />
          </KTableProvider>
        </>
      )}
    </>
  )
}

export {TableRelevosWrapper}
